import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorIcon from '../../images/icon-error.svg';

import styles from './styles.module.scss';

/**
 * Error Component
 */
class Error extends Component {

  /**
   * Render Error Component
   *
   * @returns {*}
   */
  render() {
    const { className, errorMessage } = this.props;

    return (
      <div className={[styles.Error, className].join(' ')}>
        <div className={styles.ErrorWrapper}>
          <img src={ErrorIcon} alt="Error Loading Data" className={styles.ErrorImg}/>
          <h2 className={styles.ErrorTitle}>{errorMessage}</h2>
        </div>
      </div>
    );
  }
}

Error.displayName = "Error";
Error.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
};
Error.defaultProps = {
  className: null,
  errorMessage: "Error loading data"
};

export default Error;
